import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@material-ui/core';
import { green, red } from '@avangard/ui/colors';
import { isRtl } from '@avangard/ui/utils';

type StudentFullNameProps = {
    fullName: string;
    online: boolean;
};

const Root = styled.span`
    position: relative;
`;

const StudentStatus = styled.span<{ online: boolean }>`
    content: '';
    position: relative;
    top: -7px;
    right: -3px;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${p => (p.online ? green[100] : red[100])};

    ${isRtl`
        right: initial;
        left: -3px;
    `}
`;

const StudentFullName = (props: StudentFullNameProps): React.ReactElement => {
    const { fullName, online } = props;

    const { t } = useTranslation(['common']);

    const displayOnlineTitle = online
        ? t('common:blocks.status.online')
        : t('common:blocks.status.offline');

    return (
        <Root>
            {fullName}

            {online ? (
                <Tooltip arrow placement='top' title={displayOnlineTitle}>
                    <StudentStatus online={online} />
                </Tooltip>
            ) : null}
        </Root>
    );
};

export { StudentFullName };
